
export function range(min: number, max: number){
    let res: number[] = [];
    for(let i = min; i < max; i++){
        res.push(i);
    }
    return res;
}
